export const isDevelopement = process.env.NODE_ENV === "development";
